<template>
  <Legacy
    view="reports"
    action="sales"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Sales Reports (Old)',
      breadcrumb: {
        name: 'Sales (Old)',
        route: { name: 'reports-legacy-sales' }
      }
    }
  }
}
</script>
